import { DialogContent, DialogContentText } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

export const Content = styled(DialogContent)(({ theme }) => ({
  borderTop: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
  borderBottom: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
}));

export const ContentText = styled(DialogContentText)({
  padding: "20px 0 0",
});
